import { getCountry } from '@iwIntlProvider/CountryProvider';
import { IconClockFilled } from '@iwoca/icons';
import { FormattedMessage } from 'react-intl';

import messages from './PendingView.messages';
import styles from './PendingView.module.css';
import { MainSectionWrapper } from '../../pageStructure/mainSectionWrapper';

export const PendingView = () => {
    return (
        <MainSectionWrapper className={styles.wrapper}>
            <div className={styles.card}>
                <div className={styles.iconContainer}>
                    <IconClockFilled className={styles.titleIcon} />
                </div>

                <div className={styles.title}>
                    <FormattedMessage {...messages.title} />
                </div>

                <div className={styles.bodyText}>
                    <FormattedMessage {...messages.description} />
                    {getCountry() === 'DE' && (
                        <span>
                            &nbsp;
                            <FormattedMessage
                                {...messages.contact}
                                values={{
                                    p: (chunks) => <p>{chunks}</p>,
                                    phoneNumber: (
                                        <a
                                            href="tel:069 9432 3020"
                                            className={styles.phoneNumber}
                                        >
                                            <FormattedMessage
                                                {...messages.phoneNumber}
                                            />
                                        </a>
                                    ),
                                    email: (
                                        <a
                                            href="mailto:support@iwoca.de"
                                            className={styles.phoneNumber}
                                        >
                                            <FormattedMessage
                                                {...messages.email}
                                            />
                                        </a>
                                    )
                                }}
                            />
                        </span>
                    )}
                </div>
            </div>
        </MainSectionWrapper>
    );
};
